import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class EurotunnelFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Le Shuttle",
      name: "le-shuttle",
      value,
    });
  }
}

export default EurotunnelFilter;
export { EurotunnelFilter };
